import SubscriptionIcon from './SubscriptionIcon';

export default SubscriptionIcon;
